import { onMounted, watch } from "vue";
import { useActions, useGetters } from "@/store/vuex-composition-mappers";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useDefaultThemeLogoWatcher(onChange = (changedValue: string) => {}) {
    // @ts-expect-error
    const { defaultTheme, userThemesLoaded } = useGetters("theme", [
        "defaultTheme",
        "userThemesLoaded",
    ]);
    // @ts-expect-error
    const { assureUserReady } = useActions(["assureUserReady"]);
    // @ts-expect-error
    const { getUserThemes } = useActions("theme", ["getUserThemes"]);
    watch(
        defaultTheme,
        (value, oldValue) => {
            if (value?.logo && value?.logo !== oldValue?.logo) {
                onChange(value.logo);
            }
        },
        { immediate: true }
    );

    onMounted(() => {
        assureUserReady(() => {
            // If user themes are not loaded, fetch them
            if (!userThemesLoaded.value) {
                return getUserThemes();
            }
        });
    });
}
